export const TYPE_RESULT = 'result';
export const TYPE_COMMENT = 'comment';
export const TYPE_EMAIL = 'email';
export const TYPE_DOWNLOAD = 'download';
export const TYPE_OVERDUE = 'overdue';
export const TYPE_REVIEW_COMPLETED = 'review_completed';



// WEBPACK FOOTER //
// ./src/constants/activities.js